<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 48 48"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1965 5.23449C21.394 1.54943 26.6073 1.54945 27.8048 5.23449L30.8425 14.5823L40.6715 14.5827C44.5462 14.5828 46.1572 19.541 43.0226 21.8187L35.071 27.5963L38.108 36.9443C39.3052 40.6295 35.0875 43.6938 31.9527 41.4164L24.0006 35.6394L16.0486 41.4164C12.9138 43.6938 8.69608 40.6295 9.8933 36.9443L12.9303 27.5963L4.97867 21.8187C1.84402 19.541 3.45505 14.5828 7.32978 14.5827L17.1588 14.5823L20.1965 5.23449ZM24.0006 6.4707L20.963 15.8185C20.4274 17.4665 18.8917 18.5822 17.1589 18.5823L7.32993 18.5827L15.2815 24.3603C16.6834 25.3789 17.2699 27.1842 16.7345 28.8322L13.6976 38.1803L21.6496 32.4032C23.0515 31.3848 24.9498 31.3848 26.3517 32.4032L34.3037 38.1803L31.2667 28.8322C30.7313 27.1842 31.3179 25.3789 32.7197 24.3603L40.6713 18.5827L30.8423 18.5823C29.1096 18.5822 27.5738 17.4665 27.0383 15.8185L24.0006 6.4707Z"
    />

  </svg>
</template>

<script lang="ts">
export default {
  name: "IconStarBorder",
  props: ["height", "width"],
}
</script>
